import React, { useEffect, useState } from "react";
import "../aseets/css/HeroEnterprise.css";
import gmlogo from "../aseets/gallery/gm-logo.png";
import { Link } from "react-router-dom";



const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      window.requestAnimationFrame(() => {
        setScrolled(window.scrollY > 60);
      });
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`gm-nav ${scrolled ? "gm-nav--solid" : ""}`}>
      <div className="gm-nav-inner">

        {/* Logo */}
        <div className="gm-logo">
          <Link to='/'> 
          <img src={gmlogo} alt="Global Manch logo" /></Link>
        </div>

        {/* Hamburger */}
        <button
          className={`gm-hamburger ${menuOpen ? "is-open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>

        {/* Navigation */}
        <nav
          className={`gm-nav-links ${menuOpen ? "is-open" : ""}`}
          aria-label="Primary navigation"
        >
          <Link to="/">Home</Link>
          <Link to="/about-us">About Us</Link>

          {/* SERVICES MEGA */}
          <div className="gm-nav-item has-mega">
            <span className="gm-nav-label">
              Services
              <i className="gm-caret"></i>
            </span>
            <div className="gm-mega">
              <div>
                <h4>Marketing</h4>
                <a href="#">SEO</a>
                <a href="#">Performance Marketing</a>
                <a href="#">Social Media</a>
              </div>
              <div>
                <h4>Technology</h4>
                <a href="#">Web Development</a>
                <a href="#">UI/UX Design</a>
                <a href="#">Landing Pages</a>
              </div>
            </div>
          </div>

          {/* PAGES MEGA */}
          <div className="gm-nav-item has-mega">
            <span className="gm-nav-label">More
              <i className="gm-caret"></i>
            </span>
            <div className="gm-mega">
              <div>
                <a href="#">Case Studies</a>
                <a href="#">Pricing</a>
                <a href="#">Careers</a>
              </div>
              <div>
                <a href="#">Blog</a>
                <a href="#">Contact</a>
              </div>
            </div>
          </div>
        </nav>

        {/* CTA */}
        <button className="gm-nav-cta">Get A Quote</button>
      </div>
    </header>
  );
};

export default Navbar;
